export const ROLES = { VIEWER: 'viewer', APPROVER: 'approver', SSO_ADMIN: 'sso_admin', ADMIN: 'admin' };

const ROLE_LEVEL = { viewer: 0, approver: 1, sso_admin: 2, admin: 3 };

export const hasMinRole = (userRole, requiredRole) =>
  (ROLE_LEVEL[userRole] || 0) >= (ROLE_LEVEL[requiredRole] || 0);
